import { render, staticRenderFns } from "./namePlate.vue?vue&type=template&id=94644170&scoped=true&"
import script from "./namePlate.vue?vue&type=script&lang=js&"
export * from "./namePlate.vue?vue&type=script&lang=js&"
import style0 from "./namePlate.vue?vue&type=style&index=0&id=94644170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94644170",
  null
  
)

export default component.exports